module.exports = __webpack_public_path__ + "img/board4-GLX-turqoise-54.dc52e819.jpg";